import { Paper } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { Spinner, Table } from "react-bootstrap";
import { baseUrl, config } from "../../../../services/config";
import { useAlert } from "react-alert";
import ReactToPrint from "react-to-print";
import { upperCase } from "lodash";
import { useSelector } from "react-redux";
const StaffHistory = () => {
  const user = useSelector((state) => state.user.user);
  const [empCode, setEmpCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);

  const [sessionData, setSessionData] = useState([]);
  const [historyData, setHistoryData] = useState([]);
  const [employeeHistoryTypeData, setEmployeeHistoryTypeData] = useState([]);
  const [year_id, setYear_id] = useState("");
  const [employeeHistoryTypeID, setEmployeeHistoryTypeID] = useState("");

  //for print
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const componentRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);

  let authtoken = localStorage.getItem("userToken");

  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);
  const alert = useAlert();

  useEffect(() => {
    sessions();
    getSettingData();
    getEmployeeHistoryType();
  }, []);

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data.payload);
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const sessions = () => {
    fetch(`${baseUrl}/session`, {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setSessionData(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_financial_year == "1") {
            setYear_id(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getEmployeeHistoryType = () => {
    fetch(`${baseUrl}/employee-history-types`, {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setEmployeeHistoryTypeData(data.payload);
      })
      .catch((err) => {
        console.log(err);
        setEmployeeHistoryTypeData([]);
      });
  };

  const getStaffHistory = () => {
    if (empCode === "") {
      return alert.error("Please Enter Employee Code");
    }

    let data = {
      year_id: year_id,
      employee_code: empCode,
      employee_history_type_id: employeeHistoryTypeID,
    };
    setLoading(true);
    fetch(`${baseUrl}/employee-history`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.metadata.success) {
          setHistoryData(data.payload);
          setShow(true);
        } else {
          alert.error(data.metadata.message);
          setHistoryData([]);
          setShow(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setShow(false);
      });
  };

  //for print
  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called");
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    console.log("`onBeforeGetContent` called");
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);

  const currentDate = new Date();
  const displayDate = currentDate.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });

  return (
    <>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row p-5">
          <div className="col-md-3">
            <b>
              <label>Select Session</label>{" "}
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </b>
            <select
              style={{ height: 40 }}
              className="form-select"
              name="year_id"
              value={year_id}
              aria-label="Default select example"
              onChange={(e) => setYear_id(e.target.value)}
            >
              <option value="">Select Session</option>
              {sessionData &&
                sessionData.map((item) => (
                  <option value={item.id}>{item.year}</option>
                ))}
            </select>
          </div>
          <div className="col-md-3">
            <b>
              <label>Enter Employee Code</label>{" "}
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </b>
            <input
              className="form-control"
              onChange={(e) => setEmpCode(e.target.value)}
              placeholder="Admission Id"
            />
          </div>
          <div className="col-md-3">
            <b>
              <label>Select Employee History Type</label>{" "}
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </b>
            <select
              style={{ height: 40 }}
              className="form-select"
              name="employeeHistoryTypeID"
              value={employeeHistoryTypeID}
              aria-label="Default select example"
              onChange={(e) => setEmployeeHistoryTypeID(e.target.value)}
            >
              <option value="">Select Employee History Type</option>
              {employeeHistoryTypeData &&
                employeeHistoryTypeData.map((item) => (
                  <option value={item.id}>{item.display_name}</option>
                ))}
            </select>
          </div>
          <div className="col-md-3 d-flex mt-9">
            <button className="btn btn-primary mx-2" onClick={getStaffHistory}>
              Search
            </button>
            {historyData?.length > 0 ? (
              <>
                <ReactToPrint
                  documentTitle={`Staff History Details`}
                  pageStyle="auto"
                  onAfterPrint={handleAfterPrint}
                  onBeforeGetContent={handleOnBeforeGetContent}
                  onBeforePrint={handleBeforePrint}
                  removeAfterPrint={true}
                  trigger={() => (
                    <button
                      // onClick={() => console.log("dfsdfsdfd")}
                      disabled={printloading ? true : false}
                      className="btn btn-primary w-90px mx-2"
                    >
                      {printloading ? <span>Printing..</span> : "Print"}
                    </button>
                  )}
                  content={() => componentRef.current}
                />
              </>
            ) : null}
          </div>
        </div>
        <br />

        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spinner class="text-center" variant="info" animation="border" />
          </div>
        ) : (
          <>
            {show ? (
              <>
                <div className="container">
                  <div className="row mb-1">
                    <div className="col-md-6 d-flex">
                      <h5 className="text-color-primary">
                        {historyData[historyData.length - 1]?.employee?.emp_code
                          ? "Employee Code:-"
                          : "Registration No:-"}
                      </h5>
                      <h6>
                        &nbsp; &nbsp;{" "}
                        {historyData[historyData.length - 1]?.employee?.emp_code
                          ? historyData[historyData.length - 1]?.employee
                              ?.emp_code
                          : historyData[historyData.length - 1]?.employee
                              ?.reg_code}
                      </h6>
                    </div>
                    <div className="col-md-6 d-flex">
                      <h5 className="text-color-primary">Session:-</h5>
                      <h6>
                        &nbsp; &nbsp;{" "}
                        {historyData[historyData.length - 1]?.session?.year}
                      </h6>
                    </div>
                  </div>
                  <div className="row mb-1">
                    <div className="col-md-6 d-flex">
                      <h5 className="text-color-primary">Staff Name:-</h5>
                      <h6>
                        &nbsp; &nbsp;{" "}
                        {
                          historyData[historyData.length - 1]?.employee
                            ?.full_name
                        }
                      </h6>
                    </div>
                    <div className="col-md-6 d-flex">
                      <h5 className="text-color-primary">Father Name:-</h5>
                      <h6>
                        &nbsp; &nbsp;{" "}
                        {
                          historyData[historyData.length - 1]?.employee
                            ?.father_name
                        }
                      </h6>
                    </div>
                  </div>
                </div>
                <br />
                <div id="tableboot">
                  <Table responsive>
                    <thead>
                      <tr id="tbl" className="text-center text-black">
                        <th>SrNo.</th>
                        <th>Title</th>
                        <th>Description</th>
                        <th>History Type</th>
                        <th>Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {historyData &&
                        historyData.map((item, index) => (
                          <tr id="tbl" key={index}>
                            <td className="text-center text-black">
                              {index + 1}
                            </td>
                            <td className="text-start text-black">
                              {item?.title}
                            </td>
                            <td className="text-start text-black">
                              {item?.description}
                            </td>
                            <td className="text-start text-black">
                              {item?.employee_history_type?.display_name}
                            </td>
                            <td className="text-center text-black">
                              {item?.date}
                            </td>
                            <td className="text-center text-black">
                              {item?.user?.first_name +
                                " " +
                                item?.user?.last_name}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
              </>
            ) : null}
          </>
        )}
      </Paper>

      {/* //for print */}
      <div
        ref={componentRef}
        id="printSection"
        style={{ visibility: "hidden" }}
        className="tablePrint"
      >
        <>
          {show ? (
            <>
              <div className="p-3 d-flex">
                <img
                  style={{ height: 120, width: 120 }}
                  src={icon}
                  alt="logo"
                />

                <div className="col-md-6 mr-5">
                  <h1>{unitName}</h1>
                  <h4>Staff History Report</h4>
                  <h5>Printing Date: {displayDate}</h5>
                </div>
              </div>
              <div className="container" style={{ marginTop: "20px" }}>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div className="col-md-6 d-flex">
                    <h5
                      style={{ fontSize: "18px", color: `${config.txtColor}` }}
                    >
                      {historyData[historyData.length - 1]?.employee?.emp_code
                        ? "Employee Code:-"
                        : "Registration No:-"}
                    </h5>
                    <h6 className="text-black" style={{ fontSize: "16px" }}>
                      &nbsp; &nbsp;{" "}
                      {historyData[historyData.length - 1]?.employee?.emp_code
                        ? historyData[historyData.length - 1]?.employee
                            ?.emp_code
                        : historyData[historyData.length - 1]?.employee
                            ?.reg_code}
                    </h6>
                  </div>
                  <div className="col-md-6 d-flex">
                    <h5
                      style={{ fontSize: "18px", color: `${config.txtColor}` }}
                    >
                      Session:-
                    </h5>
                    <h6 className="text-black" style={{ fontSize: "16px" }}>
                      &nbsp; &nbsp;{" "}
                      {historyData[historyData.length - 1]?.session?.year}
                    </h6>
                  </div>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div className="col-md-6 d-flex">
                    <h5
                      style={{ fontSize: "18px", color: `${config.txtColor}` }}
                    >
                      Staff Name:-
                    </h5>
                    <h6 className="text-black" style={{ fontSize: "16px" }}>
                      &nbsp; &nbsp;{" "}
                      {historyData[historyData.length - 1]?.employee?.full_name}
                    </h6>
                  </div>
                  <div className="col-md-6 d-flex">
                    <h5
                      style={{ fontSize: "18px", color: `${config.txtColor}` }}
                    >
                      Father Name:-
                    </h5>
                    <h6 className="text-black" style={{ fontSize: "16px" }}>
                      &nbsp; &nbsp;{" "}
                      {
                        historyData[historyData.length - 1]?.employee
                          ?.father_name
                      }
                    </h6>
                  </div>
                </div>
              </div>
              <br />
              <div id="tableboot">
                <Table responsive>
                  <thead>
                    <tr id="tbl">
                      <th
                        className="text-center"
                        style={{ color: "black", fontSize: "16px" }}
                      >
                        SrNo.
                      </th>
                      <th
                        className="text-start"
                        style={{ color: "black", fontSize: "16px" }}
                      >
                        Title
                      </th>
                      <th
                        className="text-start"
                        style={{ color: "black", fontSize: "16px" }}
                      >
                        Description
                      </th>
                      <th
                        className="text-start"
                        style={{ color: "black", fontSize: "16px" }}
                      >
                        History Type
                      </th>
                      <th
                        className="text-center"
                        style={{ color: "black", fontSize: "16px" }}
                      >
                        Date
                      </th>
                      <th
                        className="text-center"
                        style={{ color: "black", fontSize: "16px" }}
                      >
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {historyData &&
                      historyData.map((item, index) => (
                        <tr id="tbl" key={index}>
                          <td
                            className="text-center text-black"
                            style={{
                              color: "black",
                              fontSize: "16px",
                              borderTop: "1px solid balck",
                              borderBottom: "1px solid balck",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            className="text-start text-black"
                            style={{
                              color: "black",
                              fontSize: "16px",
                              borderTop: "1px solid balck",
                              borderBottom: "1px solid balck",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                          >
                            {item?.title}
                          </td>
                          <td
                            className="text-start text-black"
                            style={{
                              color: "black",
                              fontSize: "16px",
                              borderTop: "1px solid balck",
                              borderBottom: "1px solid balck",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                          >
                            {item?.description}
                          </td>
                          <td
                            className="text-start text-black"
                            style={{
                              color: "black",
                              fontSize: "16px",
                              borderTop: "1px solid balck",
                              borderBottom: "1px solid balck",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                          >
                            {item?.employee_history_type?.display_name}
                          </td>
                          <td
                            className="text-center text-black"
                            style={{
                              color: "black",
                              fontSize: "16px",
                              borderTop: "1px solid balck",
                              borderBottom: "1px solid balck",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                          >
                            {item?.date}
                          </td>
                          <td
                            className="text-center text-black"
                            style={{
                              color: "black",
                              fontSize: "16px",
                              borderTop: "1px solid balck",
                              borderBottom: "1px solid balck",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                          >
                            {item?.user?.first_name +
                              " " +
                              item?.user?.last_name}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
            </>
          ) : null}
        </>
      </div>
    </>
  );
};

export default StaffHistory;
